import SessionEventProto from "../session-event-proto";
import DebugPerformance from "../../gd/utils/performance";
import {SESSION_PROJECT_USERS_CHANGED} from "../../gd/bus/bus-event-type";

// const debug = "EventProjectUsersResetByProjectRecursive"
const debug = false

export default class EventProjectUsersResetByProjectRecursive extends SessionEventProto {


    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {

        debug && console.log(debug, "process()")

        DebugPerformance.start("EventProjectUsersResetByProjectRecursive")

        if (!this.data) {
            // how come ? :)
            return
        }

        if (this.isDifferentCompany()) return false;


        gd.session.projectUsers.resetForManyProjects(this.data)

        gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)


        DebugPerformance.stop("EventProjectUsersResetByProjectRecursive")

    }
}

//
// export default class EventProjectUsersResetByProjectRecursive extends EventActionProto {
//
//     constructor(uid, data) {
//         super(uid, data);
//     }
//
//     validate() {
//         return true;
//     }
//
//     process() {
//
//         if (!this.data) {
//             // how come ? :)
//             return
//         }
//
//         const groupedByProject = _.groupBy(this.data, 'projectId');
//
//         _.map(groupedByProject, (projectUsers, projectId)=>{
//             gd.session.projectUsers.resetAndKeepOldModels(projectUsers, {projectId: projectId, silent: true})
//         })
//
//         Session_reinitNavigationStructure()
//
//         // gd.session.projectUsers.trigger("reset");
//         gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED) // needed as above we do it in silent mode
//     }
//
//
// };
